var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.className({ variant: _vm.variant }),on:{"click":function($event){_vm.active = _vm.value}}},[(_vm.icon)?_c('UiIcon',{staticClass:"tw-shrink-0 tw-mr-2 tw-h-5 tw-w-5",attrs:{"name":_vm.icon,"solid":""}}):_vm._e(),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }